<template>
  <div class="page">
    <div class="header_wrap">
            <div class="header_wrap_content">
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconxiaolian1 mr5 color_green"></span></div>
                    <div class="header_wrap_text " >
                        <span>对 {{exercise_summary.practice_num_right}} 题</span>
                    </div>
                </div>
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconkulian1 mr5 color_red"></span></div>
                    <div class="header_wrap_text">错 {{exercise_summary.practice_num_error}} 题</div>
                </div>
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconfenshuduan mr5 color_yellow"></span></div>
                    <div class="header_wrap_text">得 {{exercise_summary.user_score}} 分</div>
                </div>
                <div class="header_wrap_item" >
                    <div><span class="iconfont iconbishuai mr5 color_blue"></span></div>
                    <div class="header_wrap_text"><span class="color_red">{{ current + 1 }}</span> / {{exercise_datas.length}} </div>
                </div>
                
            </div>
    </div>
    <van-swipe 
      class="my-swipe" 
      :loop="false"
      indicator-color="#1989fa"
      :touchable="touchable"
      @change="bandSlide"
    >
      <van-swipe-item @click="bandSwipeClick" v-for="(item,index) in exercise_datas" :key="index" >
        <div style="padding: 20px"  >

          <!-- 判断题 -->
          <div v-if="item.question_info.question_type==3" class="question_item" >
              <div class="question_item_title" >
                  <div class="question_item_topic" >{{index+1}}、{{item.question_info.question}}</div>
              </div>
              <div class="question_item_type" >(判断题, {{item.question_info.score}}分)</div>
              <div class="question_item_options" >
                  <van-radio-group v-model="item.user_answer">
                      <div class="question_item_option" ><span :class="['iconfont', item.icons.zhengque]"></span><van-radio :disabled="item.question_info.is_answer?true:false" name="1" :icon-size="icon_size" >正确</van-radio></div>
                      <div class="question_item_option" ><span :class="['iconfont', item.icons.cuowu]"></span><van-radio :disabled="item.question_info.is_answer?true:false" name="0" :icon-size="icon_size" >错误</van-radio></div>
                  </van-radio-group>
              </div>
              <template v-if="item.question_info.is_answer==0">
                <van-button type="info" size="normal" block style="margin-top: 40px;" @click="bandSubmit(item)"  >提交</van-button>
              </template>
              <template v-if="item.question_info.is_answer==1">
                <van-divider />
                <div class="question_evaluate">
                    <div class="question_result">
                        <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                        <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span> 
                        <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                    </div>
                    <div class="question_refer">
                        <div class="question_text_weight">正确答案</div>
                        <div class="font_size_11" >{{item.suggest_answer}}</div>
                    </div>
                    <div>
                        <div class="question_text_weight">解析</div>
                        <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                    </div>
                </div>
              </template>
          </div>

          <!-- 单选题 -->
          <div v-if="item.question_info.question_type==1" class="question_item" >
              <div class="question_item_title" >
                  <div class="question_item_topic" >{{index+1}}、{{item.question_info.question}}</div>
              </div>
              <div class="question_item_type" >(单选题, {{item.question_info.score}}分)</div>
              <div class="question_item_options" >
                  <van-radio-group v-model="item.user_answer">
                      <div v-for="(options_item,options_index) in item.question_info.question_options" 
                      :key="options_index" 
                      class="question_item_option" 
                      >
                          <span v-if="item.question_info.is_answer && item.user_answer==options_item.question_options_id && options_item.is_true" class="iconfont icondui "></span>
                          <span v-else-if="item.question_info.is_answer && item.user_answer==options_item.question_options_id && !options_item.is_true" class="iconfont iconcuo "></span>
                          <span v-else class="iconfont iconkongbai "></span>
                          <van-radio :disabled="item.question_info.is_answer?true:false" :name="options_item.question_options_id" :icon-size="icon_size" >{{options_cn[options_index]}}.{{options_item.options}}</van-radio>
                  </div>
                  </van-radio-group>
              </div>
              <template v-if="item.question_info.is_answer==0">
                <van-button type="info" size="normal" block style="margin-top: 40px;"  @click="bandSubmit(item)"  >提交</van-button>
              </template>
              <template v-if="item.question_info.is_answer==1">
                <van-divider />
                <div class="question_evaluate">
                    <div class="question_result">
                        <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                        <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span>
                        <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                    </div>
                    <div class="question_refer">
                        <div class="question_text_weight">正确答案</div>
                        <div class="font_size_11" >{{item.suggest_answer}}</div>
                    </div>
                    <div>
                        <div class="question_text_weight">解析</div>
                        <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                    </div>
                </div>
              </template>
          </div>

            <!-- 多选题 -->
          <div v-if="item.question_info.question_type==2" class="question_item" >
              <div class="question_item_title" >
                  <div class="question_item_topic" >{{index+1}}、{{item.question_info.question}}</div>
              </div>
              <div class="question_item_type" >(多选题, {{item.question_info.score}}分)</div>
              <div class="question_item_options" >
                  <van-checkbox-group v-model="item.user_answer">
                      <div 
                          v-for="(options_item,options_index) in item.question_info.question_options" 
                          :key="options_index" 
                          class="question_item_option" 
                      >
                          <span v-if="item.question_info.is_answer && item.user_answer.indexOf(options_item.question_options_id)!=-1 && options_item.is_true" class="iconfont icondui "></span>
                          <span v-else-if="item.question_info.is_answer && item.user_answer.indexOf(options_item.question_options_id)!=-1 && !options_item.is_true" class="iconfont iconcuo "></span>
                          <span v-else class="iconfont iconkongbai "></span>
                          <van-checkbox :disabled="item.question_info.is_answer?true:false" :name="options_item.question_options_id" :icon-size="icon_size" shape="square">{{options_cn[options_index]}}.{{options_item.options}}</van-checkbox>
                      </div>
                    </van-checkbox-group>
              </div>
              <template v-if="item.question_info.is_answer==0">
                <van-button type="info" size="normal" block style="margin-top: 40px;"   @click="bandSubmit(item)"  >提交</van-button>
              </template>
              <template v-if="item.question_info.is_answer==1 ">
                <van-divider />
                <div class="question_evaluate">
                    <div class="question_result">
                        <span v-if="item.question_info.user_is_true" class="question_result_tips question_text_weight color_green" >回答正确</span> 
                        <span v-if="!item.question_info.user_is_true" class="question_result_tips question_text_weight color_red" >回答错误</span>
                        <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score}}分)</span>
                    </div>
                    <div class="question_refer">
                        <div class="question_text_weight">参考答案</div>
                        <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                    </div>
                    <div>
                        <div class="question_text_weight">解析</div>
                        <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                    </div>
                </div>
              </template>
          </div>

            <!-- 填空题 -->
          <div v-if="item.question_info.question_type==4" class="question_item" >
              <div class="question_item_title" >
                  <div class="question_item_topic" >{{index+1}}、{{item.question_info.question}}</div>
              </div>
              <div class="question_item_type" >(填空题, {{item.question_info.score}}分)</div>
              <div class="question_item_options" >
                  <div 
                      v-for="(options_item,options_index) in item.question_info.question_options" 
                      :key="options_index"   
                      class="question_item_option" 
                  >
                      <span class="iconfont iconkongbai"></span>
                      <van-field 
                          :label-width="label_width" 
                          :name="options_item.question_options_id"  
                          v-model="item.user_answer[options_index]" 
                          :label="options_index+1" 
                          placeholder='请输入你回答' 
                      />
                  </div>
              </div>
              <template v-if="item.question_info.is_answer==0">
                <van-button type="info" size="normal" block style="margin-top: 40px;"  @click="bandSubmit(item)"  >提交</van-button>
              </template>

              <template v-if="item.question_info.is_answer==1">
                <van-divider />
                <div class="question_evaluate">
                    <div class="question_result">
                        <span class="question_result_tips question_text_weight" >评分结果</span> 
                        <span class="question_result_scores font_size_11">(得分：{{item.question_info.user_score+'分'?item.question_info.user_score:'评定中'}})</span>
                    </div>
                    <div class="question_refer">
                        <div class="question_text_weight">参考答案</div>
                        <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                    </div>
                    <div>
                        <div class="question_text_weight">解析</div>
                        <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                    </div>
                </div>
                <div>
                    <van-divider />
                    <div>
                        <div class="question_text_weight question_teacher_comment">老师评语</div>
                        <div class="font_size_11" >{{ item.question_info.user_comment?item.question_info.user_comment:'老师正在努力批阅中'}}</div>
                    </div>
                </div>
              </template>
          </div>

            <!-- 问答题 -->
          <div v-if="item.question_info.question_type==5" class="question_item" >
              <div class="question_item_title" >
                  <div class="question_item_topic" >{{index+1}}、{{item.question_info.question}}</div>
              </div>
              <div class="question_item_type" >(问答题, {{item.question_info.score}}分)</div>
              <div class="question_item_options" >
                  <div>
                      <van-field
                          v-model="item.user_answer.text"
                          rows="5"
                          autosize
                          type="textarea"
                          placeholder="请填写你的回答"
                      />
                  </div>
                  <div>
                      <div v-if="essay_question_type==1" class="question_essay"  >
                          <div class="iconfont_wrap"><span class="iconfont iconcomiistupian mr5 size25"></span></div>
                          <div class="iconfont_wrap"><span class="iconfont iconyinpin mr5 size25"></span></div>
                      </div>
                      <div v-if="item.user_answer.images" class="question_essay_type_2">
                          <van-uploader 
                              :ref="item.question_info.test_question_id" 
                              v-model="item.user_answer.images" 
                              multiple 
                              :max-count="9" 
                              :deletable="false"
                              :show-upload="false"
                          />
                      </div>
                      <div v-if="item.user_answer.audio" style="padding:3px;">
                          <m-audio :src="item.user_answer.audio"></m-audio>
                      </div>
                  </div>
              </div>
              <template v-if="item.question_info.is_answer==0">
                <van-button type="info" size="normal" block style="margin-top: 40px;"  @click="bandSubmit(item)"  >提交</van-button>
              </template>
              <template v-if="item.question_info.is_answer==1">
                <van-divider />
                <div class="question_evaluate">
                    <div class="question_result">
                        <span class="question_result_tips question_text_weight" >评分结果</span> 
                        <span class="question_result_scores font_size_11">(得分：{{ item.question_info.user_score+'分'?item.question_info.user_score:'评定中'}})</span>
                    </div>
                    <div class="question_refer">
                        <div class="question_text_weight">参考答案</div>
                        <div class="font_size_11" >{{item.suggest_answer?item.suggest_answer:'暂无'}}</div>
                    </div>
                    <div>
                        <div class="question_text_weight">解析</div>
                        <div class="font_size_11" >{{item.question_info.description?item.question_info.description:'暂无解析'}}</div>
                    </div>
                </div>
                <div>
                    <van-divider />
                    <div>
                        <div class="question_text_weight question_teacher_comment">老师评语</div>
                        <div class="font_size_11" >{{ item.question_info.user_comment?item.question_info.user_comment:'老师正在努力批阅中'}}</div>
                    </div>
                </div>
               </template>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="next" >
        <span class="iconfont iconshuangjiantouyou mr5 "></span>
    </div>
    <div class="prev" >
        <span class="iconfont iconshuangjiantouzuo mr5 "></span>
    </div>
  </div>
</template>


<script>
import {Image as VanImage,Divider, Toast, Swipe, SwipeItem, Form,Field,RadioGroup, Radio,Checkbox, CheckboxGroup,Button,Uploader, ActionSheet,CountDown,Empty,Dialog} from 'vant';
export default {
        name: "index",
        components:{
           [VanImage.name]:VanImage,
           [Swipe.name]:Swipe,
           [SwipeItem.name]:SwipeItem,
           [Form .name]:Form,
            [Field .name]:Field,
            [RadioGroup .name]:RadioGroup,
            [Radio .name]:Radio,
            [Checkbox .name]:Checkbox,
            [CheckboxGroup .name]:CheckboxGroup,
            [Button .name]:Button,
            [Uploader .name]:Uploader,
            [ActionSheet .name]:ActionSheet,
            [CountDown .name]:CountDown,
            [Empty .name]:Empty,
            [Dialog  .name]:Dialog ,
            [Divider .name]:Divider,
            [Toast .name]:Toast,
        },
        data(){
            return {
                bodyShow: true,
                touchable: true,
                essays:[],
                essay_question_images:[],
                essay_question_type:1,
                current: 0,
                totalTopic: 4,
                icon_size: "18px",
                options_cn: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N'],
                exercise_datas: [],
                exercise_summary: {
                    practice_num_error:0,
                    practice_num_right:0,
                    user_score:0,
                },
                next_show: 1,
                icons:{
                    defaulticon:'iconkongbai',
                    icondui:'icondui',
                    iconcuo:'iconcuo'
                },
                exercise_info:[]
            }
        },
        created(){
          //this.preDatas()
        },
        mounted() {
            this.$(document).attr('title','练习')
            this.practice_id = this.$route.query.practice_id
            this.study_id = this.$route.query.study_id
            this.get_question()
        },
        methods:{
            init(){

            },
            get_question(){
                var _self=this;
                this.util.server.mini_training.get_question({
                    data:{
                        practice_id: this.practice_id,
                        object_type: 1,
                        object_id: this.study_id,
                    },
                    callback:(res => {
                        console.log('1',res)
                        const { code, data, msg } = res;

                        _self.exercise_summary.practice_num_error = data.practice_num_error
                        _self.exercise_summary.practice_num_right = data.practice_num_right
                        _self.exercise_summary.user_score = data.user_score
                        _self.preDatas(data.practice_info)
                    })
                })
            },
            preDatas(exercise_info){
              //预处理数据
              let datas = exercise_info;
              datas.forEach((value,index,array) => {
                  console.log(value)
                  value.suggest_answer = '';
                  //单选题
                  if(value.question_info.question_type==1){
                      value.user_answer = value.question_info.user_question_answer
                      
                      value.question_info.question_options.forEach((v,i,arr) =>{
                          if(v.is_true==1){
                              value.suggest_answer = this.options_cn[i]
                          }
                      })
                  }
                  //多选题
                  if(value.question_info.question_type==2){
                      value.user_answer = value.question_info.user_question_answer
                        let sug = []
                      value.question_info.question_options.forEach((v,i,arr) =>{
                          if(v.is_true==1){
                              sug.push(this.options_cn[i])
                          }
                      })
                      value.suggest_answer = sug.toString()
                  }
                  //判断题
                  if(value.question_info.question_type==3){
                      value.user_answer = value.question_info.user_question_answer
                      let icon = {zhengque:this.icons.defaulticon, cuowu: this.icons.defaulticon}

                      console.log('value.user_answer', value.user_answer)
                      console.log('value.question_info.question_options[0].is_true',value.question_info.question_options[0].is_true)

                      if(value.question_info.is_answer && value.user_answer==1){
                          icon.zhengque = value.user_answer==value.question_info.question_options[0].is_true?this.icons.icondui:this.icons.iconcuo
                      }
                      if(value.question_info.is_answer && value.user_answer==0){
                          icon.cuowu = value.user_answer==value.question_info.question_options[0].is_true?this.icons.icondui:this.icons.iconcuo
                      }
                      value.icons = icon
                      value.suggest_answer = value.question_info.question_options[0].is_true?'正确':'错误'
                  }
                  //填空题
                  if(value.question_info.question_type==4){
                      value.user_answer = new Array(value.question_info.question_options.length);
                      let sug = []
                      value.question_info.question_options.forEach((function(item,index,arr) { 
                          sug.push(item.options)
                      }))
                      value.suggest_answer = sug.toString()
                      value.user_answer = value.question_info.user_question_answer
                  }
                  //问答题
                  if(value.question_info.question_type==5){
                      // value.user_answer = {}
                      // value.user_answer.type = 1
                      
                      // value.user_answer.audio = ''
                      // value.user_answer.text = ''
                      value.user_answer = value.question_info.user_question_answer
                      // value.user_answer.images = [
                      //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                      //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                      //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                      //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                      //     {'url':'https://o-yzx.bysjy.com.cn/course/1598018640-6989.jpg'},
                      // ]
                  }
                  
              });
              console.log(datas)
              this.exercise_datas = datas

            },
            bandSubmit(item){
                var _self = this
                console.log('元素item1',item)
                console.log('user_answer',item.user_answer)
                // 如果答案为空
                if( item.question_info.question_type == 5 ){ 
                    if( item.user_answer.text == undefined){
                        Toast('忘记选择填写答案啦');
                        return
                    }
                }else{
                    if(item.user_answer.length==0){ 
                        Toast('忘记选择回答选项啦');
                        return
                    }
                }
                
                
                this.util.server.mini_training.answer({
                    data:{
                        practice_id: this.practice_id,
                        object_type: 1,
                        object_id: this.study_id,
                        answers:[
                           {
                                practice_question_id: item.question_info.practice_question_id,
                                answer: item.user_answer
                           }
                        ]
                    },
                    callback:(res => {
                        const { code, data, msg } = res;
                        const answer = data.answer[0];
                        console.log('data111',data)
                        item.question_info.is_answer = 1
                        item.question_info.user_is_true = answer.user_is_true
                        _self.exercise_summary.user_score += answer.score
                        if(answer.user_is_true == 1){
                            _self.exercise_summary.practice_num_right ++
                        }
                        if(answer.user_is_true == 0){
                            _self.exercise_summary.practice_num_error ++
                        }
                        
                    })
                })
            },
            bandSlide(index){
              console.log("滑动了",index)
              this.current = index;
              if(index>1){
                //this.touchable = false
              }
              this.next_show = 0
            },
            bandSwipeClick(index){
              console.log("点击了")
              this.next_show = 1
            },
            bindToPhase(){
                this.$router.push(this.util.urlPrefix+'/training/phase?id='+this.detail.training_id+'&token='+this.util.token)
            },
        }
    }

</script>

<style scoped>
.header{
  height: 50px;
  background-color: #FFF;
  box-shadow: 0 2px 12px 0 rgba(100, 88, 88, 0.1);
  position: relative;
  z-index: 999;
}
.my-swipe .van-swipe-item {
    font-size: 20px;
    background-color: #FFF;
    width: 100%;
    height: calc(100vh - 70px);
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .my-swipe .van-swipe-item::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    display: none;
  }
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.1);
  }

 .header_wrap{
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 0.125rem 0.75rem 0 rgba(0,0,0,0.1);
    position: relative;
    z-index: 999;
  }
 .header_wrap_content{
    padding: 18px;
    display: flex;
    box-sizing:border-box;
    justify-content: space-between;
  }
 .header_wrap_item{
    width: 70px;
    height: 40px;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  .header_wrap_text{
    font-size: 12px;
  }
  .header_wrap_text .van-count-down{
    color: red;
  }
  .color_red{
    color: red;
  }
  .color_green{
    color: rgb(99, 238, 34);
  }
  .color_yellow{
    color: #ffa500;
  }
  .color_blue{
    color: #13addb;
  }
  
  .question_item{
    background-color:  #ffffff;
    margin-bottom: 15px;
  }
  .question_item_title{
      display: flex;
  }
  .question_item_seq{
      width: 25px;
  }
  .question_item_topic{
      line-height: 25px;
  }
  .question_item_type{
      padding-left: 8px;
      color: #CCC;
  }
  .van-radio{
      margin-top: 20px;
  }
  .van-checkbox{
      margin-top: 20px;
  }
  .van-field{
      margin-top: 5px;
      padding-left: 0px;
  }
  .question_essay{
      display: flex;
  }
  .question_essay_type_2{
      display: flex;
      box-sizing:border-box;
      flex-wrap: wrap;
  }
  .iconfont_wrap{
      padding: 5px;
  }
  .size25{
      font-size: 25px;
  }
  .size35{
      font-size: 35px;
  }
  .essay_item_wrap{
      width: 23%;
      height: 20vw;
      padding: 5px 1%;
  }
  .essay_item_wrap img{
      width: 100%;
      height: 100%;
      object-fit: cover;
  }
  .add_img_button{
      width: 100%;
      height: 100%;
      background-color: #CCC;
      display: flex;
      justify-content:center;
      align-items:center;
      color: aliceblue;
      cursor: pointer;
  }
  .question_item_option{
      display: flex;
  }
  .question_item_option span{
      margin-top: 20px;
      margin-right: 10px;
  }
  .icondui{
      color: rgb(59, 228, 59);
  }
  .iconcuo{
      color: red;
  }
  .font_size_11{
      font-size: 11px;
      color: #ccc;
  }
  .question_result_tips{
      font-size: 16px;
  }
  .question_result_scores{
      padding-left: 5px;
  }
  .question_text_weight{
      font-weight: 600;
      padding-bottom: 5px;
  }
  .question_refer{
      padding: 12px 0px;
  }
  .question_teacher_comment{
      font-size: 16px;
      color: #f57932;
  }
  .next{
    position: absolute;
    bottom: 52%;
    right: 0px;
    animation:movetoright 800ms;
    opacity: 0;
  }
  .prev{
    position: absolute;
    bottom: 52%;
    left: 0px;
    animation:movetoleft 800ms;
    opacity: 0;
  }
  .my-swipe >>> .van-swipe__indicator{
    background-color: rgba(12, 12, 12, 0.8);
  }

  .next .iconshuangjiantouyou{
    color: rgba(240, 9, 9, 0.5);
    font-size: 40px;
  }
  .prev .iconshuangjiantouzuo{
    color: rgba(240, 9, 9, 0.5);
    font-size: 40px;
  }
  

  @-webkit-keyframes movetoright /* Safari and Chrome */
    {
        0%   {right:10px; opacity: 1;}
        10%   {right:9px; opacity: 0.9;}
        20%   {right:8px; opacity: 0.8;}
        30%   {right:7px; opacity: 0.7;}
        40%   {right:6px; opacity: 0.6;}
        50%   {right:5px; opacity: 0.5;}
        60%   {right:4px; opacity: 0.4;}
        70%   {right:3px; opacity: 0.3;}
        80%   {right:2px; opacity: 0.2;}
        90%   {right:1px; opacity: 0.1;}
        100%  {right:0px; opacity: 0;}
    }

    @-webkit-keyframes movetoleft /* Safari and Chrome */
    {
        0%   {left:10px; opacity: 1;}
        10%   {left:9px; opacity: 0.9;}
        20%   {left:8px; opacity: 0.8;}
        30%   {left:7px; opacity: 0.7;}
        40%   {left:6px; opacity: 0.6;}
        50%   {left:5px; opacity: 0.5;}
        60%   {left:4px; opacity: 0.4;}
        70%   {left:3px; opacity: 0.3;}
        80%   {left:2px; opacity: 0.2;}
        90%   {left:1px; opacity: 0.1;}
        100%  {left:0px; opacity: 0;}
    }

    

</style>
